import React from 'react';
import ViewAll from './components/view-all-functional';
const ViewALLPage = () => {
	return <ViewAll />;
};
export default ViewALLPage;
